import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ShareComponent from './EnhancedTableToolbarShareMenu/EnhancedTableToolbarShareMenu';
import ItemsPerPageComponent from './EnhancedTableToolbarItemsPerPage';
import TableSettingsComponent from './EnhancedTableToolbarTableSettings';
import FilterComponent from './EnhancedTableToolbarFilterMenu';
import EnhancedTableToolbarItemActionList from './EnhancedTableToolbarItemActionList';
import SelectionPreviewComponent from './EnhancedTableToolbarSelectionPreview';
import EnhancedTableToolbarButton from './EnhancedTableToolbarButton';
import { useEnhancedDataTableContext } from '../EnhancedDataTableContext';

const EnhancedTableToolbar = React.memo((props) => {
  const {
    onItemsPerPageChange,
    onFilterIconClicked,
    onTableSettingsChange,
    onTableSettingResetToDefault,
  } = props;
  const {
    totalRows,
    itemInCurrentPage,
    onItemActionClick,
    handleRowCheckChange,
    onExportClick,
  } = props;
  const context = useEnhancedDataTableContext();
  const { showExport = true, showFilterToggle = true, showTableSettings = true } = context;

  const [openPopup, setOpenPopup] = useState(false);
  const [isItemActionClicked, setItemActionClicked] = useState(true);
  return (
    <div id="tableToolbar" className="col-md-12 pad-0-lr">
      <div id="tableToolbar-float-left" style={{ float: 'left' }}>
        <ItemsPerPageComponent
          totalRows={totalRows}
          itemInCurrentPage={itemInCurrentPage}
          onItemsPerPageChange={onItemsPerPageChange}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}

        />
        <SelectionPreviewComponent
          totalRows={totalRows}
          handleRowCheckChange={handleRowCheckChange}
          openPopup={openPopup}
        />
      </div>
      <div id="tableToolbar-float-right" style={{ float: 'right' }}>
        <EnhancedTableToolbarButton />
        <EnhancedTableToolbarItemActionList
          onItemActionClick={onItemActionClick}
          isItemActionClicked={isItemActionClicked}
          setItemActionClicked={setItemActionClicked}
        />
        {showExport && (
          <ShareComponent
            onExportClick={onExportClick}
            setItemActionClicked={setItemActionClicked}
          />
        )}
        {showFilterToggle && (
          <FilterComponent
            onFilterClicked={onFilterIconClicked}
            setItemActionClicked={setItemActionClicked}
          />
        )}
        {showTableSettings && (
          <TableSettingsComponent
            onTableSettingsChange={onTableSettingsChange}
            onItemsPerPageChange={onItemsPerPageChange}
            onTableSettingResetToDefault={onTableSettingResetToDefault}
            setItemActionClicked={setItemActionClicked}
          />
        )}
      </div>
    </div>
  );
});

EnhancedTableToolbar.propTypes = {
  onItemsPerPageChange: PropTypes.func.isRequired,
};

EnhancedTableToolbar.displayName = 'EnhancedTableToolbar';

EnhancedTableToolbar.propTypes = {
  onItemsPerPageChange: PropTypes.func.isRequired,
  onFilterIconClicked: PropTypes.func.isRequired,
  onTableSettingsChange: PropTypes.func.isRequired,
  onTableSettingResetToDefault: PropTypes.func.isRequired,
  totalRows: PropTypes.number.isRequired,
  itemInCurrentPage: PropTypes.number.isRequired,
  actionList: PropTypes.shape({}),
  onItemActionClick: PropTypes.func,
  handleRowCheckChange: PropTypes.func,
  onExportClick: PropTypes.func,
};

export default EnhancedTableToolbar;
